import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Button } from '@toasttab/shared/src/components'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import { useI18next } from '@toasttab/shared/src//hooks/useI18next'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'

const MobileStickyCta = () => {
  const { t } = useI18next()
  const [visible, setVisible] = useState<boolean>(false)
  const [boundaryBottom, setBoundaryBottom] = useState<number>(0)
  const showSK: boolean = false

  const { url } = usePageContext()

  useEffect(() => {
    const boundary = document.querySelector<HTMLElement>(
      '[data-mobile-cta-boundary]'
    )
    const boundaryValue =
      (boundary && boundary.getBoundingClientRect().bottom + window.scrollY) ||
      window.innerHeight
    setBoundaryBottom(boundaryValue)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', () => {
      const driftWidget = document.querySelector<HTMLElement>(
        '#drift-frame-controller'
      )
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollTop > boundaryBottom) {
        setVisible(true)
        if (driftWidget) {
          driftWidget.style.bottom = '140px'
        }
      } else {
        setVisible(false)
        if (driftWidget) {
          driftWidget.style.bottom = '20px'
        }
      }
    })
  }, [boundaryBottom])
  const stickyCtaClass = classNames(
    'py-4 fixed lg:hidden bg-white w-full transition-[bottom,_shadow] duration 1s ease-in-out',
    {
      'shadow-mobile-sticky-cta !bottom-0 z-85': visible,
      '-bottom-full z-0': !visible
    }
  )
  return (
    <div className={stickyCtaClass}>
      <div className='text-center mx-auto w-full sm:w-2/3 md:w-[50%] px-4 md:px-6 '>
        <Button
          {...(url === '/request-demo'
            ? { onClick: () => window.scrollTo(0, 0) }
            : { href: '/request-demo' })}
          classes='inline-block mb-4 heap-mobile-sticky-cta-demo-button'
          fontWeight={['font-semibold']}
          fullwidth
          size='large'
          variation='primary'
        >
          {t(`Get a Free Demo`)}
        </Button>
        {showSK && (
          <div className='font-sansPro text-base text-secondary leading-6'>
            {t(`Under 10 Employees?`)}
            <TextLink
              classes='ml-4 heap-mobile-sticky-cta-starter-kit-link'
              href='/shop/starter-kits'
              icon='arrow'
              text='Shop Starter Kit'
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default MobileStickyCta
